// extracted by mini-css-extract-plugin
export default {"statusbar":"statusbar__FCEC75","progress":"progress__qYXkW8","progressTitle":"progressTitle__ZenKyp"};